import type { DashboardWidgetLayoutItem } from './dashboardWidgets';

// Panel layout per user, kept in this browser only. It is a viewer convenience,
// not shared state: another device or a cleared site-data store falls back to
// the default layout. Persisting it server-side needs a new column and a
// reviewed migration (see backend/src/db/run-migrations.js).
const STORAGE_PREFIX = 'flowship.dashboardLayout.v2';

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}.${userId}`;
}

// null = never saved or reset to default. Any read failure (private window,
// blocked storage, corrupt JSON) also means default, never a broken page.
export function readDashboardLayout(userId: string | undefined): unknown {
  if (!userId) return null;
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    return raw === null ? null : JSON.parse(raw);
  } catch {
    return null;
  }
}

// Throws when storage is unavailable so the caller can tell the user the
// layout was not kept, instead of showing a success that will not survive reload.
export function writeDashboardLayout(userId: string | undefined, layout: DashboardWidgetLayoutItem[] | null): void {
  if (!userId) throw new Error('Dashboard layout needs a signed-in user');
  if (layout === null) {
    window.localStorage.removeItem(storageKey(userId));
    return;
  }
  window.localStorage.setItem(storageKey(userId), JSON.stringify(layout));
}
